import { render, staticRenderFns } from "./SyncInfoCard.vue?vue&type=template&id=93f5ba3e&"
import script from "./SyncInfoCard.vue?vue&type=script&lang=js&"
export * from "./SyncInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports